import Typesense from 'typesense';
import { autocomplete } from '@algolia/autocomplete-js';

window.addEventListener('DOMContentLoaded', () => {

	const searchEl = document.getElementById('autocomplete');
	const searchDataEl = document.getElementById('search-connection');
	if (searchEl && searchDataEl) {
		const apiKey = searchDataEl.dataset.apiKey;
		const host = searchDataEl.dataset.host;
		const port = searchDataEl.dataset.port;
		const protocol = searchDataEl.dataset.protocol;
		const path = searchDataEl.dataset.path || '';

		if (!apiKey || !host || !port || !protocol) {
			return
		};

		const onClickCloseSearchButton = () => {
			const modalEl = document.getElementById('search-modal');
			if (modalEl) {
				modalEl.classList.remove('visible');
			}
			const bodyElList = document.getElementsByTagName('body');
			if (bodyElList && bodyElList.length > 0) {
				bodyElList[0].classList.remove('prevent-scroll');
			}
			const navElList = document.getElementsByTagName('nav');
			if (navElList && navElList.length > 0) {
				navElList[0].classList.remove('prevent-click');
			}
		}

		const onClickSearchButton = () => {
			const modalEl = document.getElementById('search-modal');
			if (modalEl) {
				if (modalEl.classList.contains('visible')) {
					onClickCloseSearchButton();
				} else {
					modalEl.classList.add('visible');
					const bodyElList = document.getElementsByTagName('body');
					if (bodyElList && bodyElList.length > 0) {
						bodyElList[0].classList.add('prevent-scroll');
					}
					const navElList = document.getElementsByTagName('nav');
					if (navElList && navElList.length > 0) {
						navElList[0].classList.add('prevent-click');
					}
					const autocompleteEl = document.getElementById('autocomplete-0-input');
					const mobileAutocompleteButtonEl = document.getElementById('autocomplete-0-label');
					if (autocompleteEl) {
						autocompleteEl.focus();
					} else if (mobileAutocompleteButtonEl && mobileAutocompleteButtonEl.nodeName === 'BUTTON') {
						mobileAutocompleteButtonEl.click();
						const mobileClearButtonElList = document.getElementsByClassName('aa-DetachedCancelButton');
						if (mobileClearButtonElList.length > 0) {
							mobileClearButtonElList[0].addEventListener('click', onClickCloseSearchButton);
						}
					}
				}
			}
		}

		const handleKeyDown = (event) => {
			// For Mac: metaKey is Command, for Windows/Linux: ctrlKey is Ctrl.
			if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
				event.preventDefault();
				onClickSearchButton();
			}
		};

		window.addEventListener("keydown", handleKeyDown);

		const searchButtonElList = document.getElementsByClassName('search-button');
		if (searchButtonElList && searchButtonElList.length) {
			[...searchButtonElList].forEach((searchButtonEl) => {
				searchButtonEl.addEventListener('click', onClickSearchButton);
			})
		}

		const modalCloseButtonEl = document.getElementById('search-modal-close-button');
		if (modalCloseButtonEl) {
			modalCloseButtonEl.addEventListener('click', onClickCloseSearchButton);
		}

		const searchModalEl = document.getElementById('search-modal');
		if (searchModalEl) {
			searchModalEl.addEventListener('click', (e) => {
				if (e.target?.id === 'search-modal') {
						onClickCloseSearchButton();
				}
			});
		}

		let typesenseClient = new Typesense.Client({
			'nodes': [
				{'host': host, 'port': port, 'protocol': protocol, 'path': path},
			],
			'apiKey': apiKey,
			'connectionTimeoutSeconds': 2
		});

		let searchRequests = {
			'union': true,
			'searches': [
				{
					"collection": "ghn_contact",
					"query_by": "first_name,last_name"
				},
				{
					"collection": "ghn_organisation",
					"query_by": "name,organisation_number"
				},
				{
					"collection": "ghn_meeting",
					"query_by": "organisation_name,address,zip_code,city,country_name"
				}
			]
		};

		const ac = autocomplete({
			container: '#autocomplete',
			panelContainer: '#search-modal-wrapper',
			placeholder: 'Search for organisation, contact or meeting',
			detachedMediaQuery: 'none',
			async getSources({query}) {
				const results = await typesenseClient.multiSearch.perform(searchRequests, { q: query });

				return [
					{
						sourceId: 'predictions',
						onSelect({ item }) {
							if (item?.document?.href) {
								const { origin } = window.location;
								let language = '/en'
								const searchModalEl = document.getElementById('search-modal');
								if (searchModalEl && searchModalEl?.dataset?.language) {
									language = `/${searchModalEl?.dataset?.language}`
								}
								window.location.href = `${origin}${language}${item.document.href}`
							}
						},
						getItems() {
							return results.hits;
						},
						getItemInputValue({item}) {
							let name;
							switch (item['collection']) {
								case 'ghn_contact':
									name = `${item.document.first_name} ${item.document.last_name}`
								break;
								case 'ghn_organisation':
									name = `${item.document.name}`
								break;
								case 'ghn_meeting':
									name = `${item.document.organisation_name}`
								break;
							}
							return name;
						},
						templates: {
							item({ item, html }) {
								const { origin } = window.location;
								let language = '/en'
								const searchModalEl = document.getElementById('search-modal');
								if (searchModalEl && searchModalEl?.dataset?.language) {
									language = `/${searchModalEl?.dataset?.language}`
								}
								const url = `${origin}${language}${item.document.href}`;
								// Html is from the `htm` package. Docs: https://github.com/developit/htm, see link for more info.
								// Get the highlighted HTML fragment from Typesense results.
								let first_paragraph_fragment = '';
								let iconClass = '';
								switch (item['collection']) {
									case 'ghn_contact':
										if (item.highlight?.first_name?.snippet) {
											first_paragraph_fragment = `${item.highlight.first_name.snippet}`;
										} else {
											first_paragraph_fragment = `${item.document.first_name}`;
										}
										if (item.highlight?.last_name?.snippet) {
											first_paragraph_fragment +=  ` ${item.highlight.last_name.snippet}`
										} else {
											first_paragraph_fragment +=  ` ${item.document.last_name}`
										}
										iconClass = 'fa-address-book';
									break;
									case 'ghn_organisation':
										if (item.highlight?.name?.snippet) {
											first_paragraph_fragment = `${item.highlight.name.snippet}`
										} else {
											first_paragraph_fragment = `${item.document.name}`
										}
										iconClass = 'fa-building';
									break;
									case 'ghn_meeting':
										if (item.highlight?.organisation_name?.snippet) {
											first_paragraph_fragment = `${item.highlight.organisation_name.snippet}`
										} else {
											first_paragraph_fragment = `${item.document.organisation_name}`
										}
										iconClass = 'fa-calendar';
									break;
								}

								// Send the html_fragment to `html` tagged template.
								// Reference: https://github.com/developit/htm/issues/226#issuecomment-1205526098, see link for more info.
								return html`<a href="${url}" class="search-result-row"><i class="fa-regular fa-fw ${iconClass}"></i><p dangerouslySetInnerHTML=${{ __html: first_paragraph_fragment }}></p></div>`
							},
							noResults() {
								return 'No results found.';
							},
						},
					},
				];
			},
		});

		// === Recording UI elements ===
		const startBtn   = document.getElementById('search-modal-record-button');
		const recordIcon = document.getElementById('record-icon');
		const waveCanvas = document.getElementById('record-wave');

// === Recorder state ===
		let recorder, allChunks = [];
		let mediaStream = null;

// === Waveform state ===
		let audioCtx = null;
		let analyser = null;
		let dataArray = null;
		let rafId = null;

		const pickMimeType = () => {
			const candidates = [
				'audio/webm;codecs=opus',
				'audio/webm',
				'audio/mp4;codecs=mp4a.40.2', // Safari fallback
				'audio/mp4'
			];
			for (const m of candidates) {
				if (window.MediaRecorder && MediaRecorder.isTypeSupported(m)) return m;
			}
			return ''; // let browser choose
		};

		const setRecordingUI = (isRecording) => {
			if (!startBtn) return;
			if (isRecording) {
				startBtn.classList.add('is-recording');
				if (recordIcon) recordIcon.className = 'fa-regular fa-square'; // stop icon
				if (waveCanvas) waveCanvas.style.display = 'block';
			} else {
				startBtn.classList.remove('is-recording');
				if (recordIcon) recordIcon.className = 'fa-regular fa-microphone';
				stopWaveform();
			}
		};

// Waveform drawing
		const drawWaveform = () => {
			if (!analyser || !waveCanvas) return;
			const ctx = waveCanvas.getContext('2d');

			const render = () => {
				if (!analyser) return;
				// Match canvas width to CSS width each frame (handles resizes)
				waveCanvas.width = waveCanvas.clientWidth;
				const W = waveCanvas.width;
				const H = waveCanvas.height;

				const bufferLength = analyser.fftSize;
				if (!dataArray || dataArray.length !== bufferLength) {
					dataArray = new Uint8Array(bufferLength);
				}

				analyser.getByteTimeDomainData(dataArray);

				ctx.clearRect(0, 0, W, H);
				ctx.beginPath();
				for (let x = 0; x < W; x++) {
					const i = Math.floor((x / W) * bufferLength);
					const v = dataArray[i] / 128.0;
					const y = (v * H) / 2;
					if (x === 0) ctx.moveTo(x, y);
					else ctx.lineTo(x, y);
				}
				ctx.lineWidth = 2;
				ctx.strokeStyle = '#4f46e5'; // tweak or remove if you style elsewhere
				ctx.stroke();

				rafId = requestAnimationFrame(render);
			};

			cancelAnimationFrame(rafId);
			rafId = requestAnimationFrame(render);
		};

		const stopWaveform = () => {
			cancelAnimationFrame(rafId);
			rafId = null;
			if (waveCanvas) {
				const ctx = waveCanvas.getContext('2d');
				ctx.clearRect(0, 0, waveCanvas.width, waveCanvas.height);
				waveCanvas.style.display = 'none';
			}
		};

// Start recording (no chunks sent mid-recording)
		const startRecording = async () => {
			allChunks = [];
			mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });

			// Analyser for waveform
			audioCtx = new (window.AudioContext || window.webkitAudioContext)();
			const source = audioCtx.createMediaStreamSource(mediaStream);
			analyser = audioCtx.createAnalyser();
			analyser.fftSize = 2048;
			source.connect(analyser);
			drawWaveform();

			const mimeType = pickMimeType();
			recorder = new MediaRecorder(mediaStream, mimeType ? { mimeType } : {});
			recorder.ondataavailable = (e) => {
				if (e.data && e.data.size > 0) allChunks.push(e.data);
			};
			recorder.onstop = async () => {
				setRecordingUI(false);

				// Close audio graph
				try { if (audioCtx && audioCtx.state !== 'closed') await audioCtx.close(); } catch {}
				audioCtx = null; analyser = null;

				// Stop tracks
				if (mediaStream) {
					mediaStream.getTracks().forEach(t => t.stop());
					mediaStream = null;
				}

				// Build one final blob and send
				const finalType = mimeType || (allChunks[0] && allChunks[0].type) || 'audio/webm';
				const fullBlob = new Blob(allChunks, { type: finalType });
				await sendRecordingToServer(fullBlob);
			};

			recorder.start(); // no timeslice => single final dataavailable on stop
			setRecordingUI(true);
		};

		const stopRecording = () => {
			if (recorder && recorder.state !== 'inactive') {
				recorder.stop();
			}
		};

		const recordButtonFunction = async (element) => {
			if (element.classList.contains('is-recording')) {
				stopRecording();
			} else {
				await startRecording();
			}
		};

		if (startBtn) {
			startBtn.onclick = () => recordButtonFunction(startBtn);
		}

		// Send once after stop
		async function sendRecordingToServer(blob) {
			try {
				const file = new File([blob], `recording-${Date.now()}.webm`, {
					type: blob.type || 'audio/webm'
				});
				const formData = new FormData();
				formData.append('audio', file);

				const { origin } = window.location;
				const res = await fetch(`${origin}/include/ajax/audio_transcribe.php`, {
					method: 'POST',
					body: formData
				});

				if (res.ok) {
					const json = await res.json();
					if (json?.text?.text) {
						const inputEl = document.getElementById('autocomplete-0-input');
						if (inputEl) {
							const cleaned = json.text.text.replace(/[\n\.,]/g, '');
							ac.setQuery(cleaned); // 'ac' is your autocomplete instance above
							inputEl.focus();
						}
					}
				}
			} catch (err) {
				console.error('Transcribe error:', err);
			}
		}
	}
});
